import React, { useEffect, useState } from "react";
import LeadDetailsSubModals from "../../../../../components/organisms/LeadHistory/LeadDetailsSubModals";
import { accessLocation } from "../../../../../utils/helpers/helperMethods/Leads/adressHelper";
import { useHandleConfirm } from "../../../../../hooks/useHandleConfirm";
import { SpecificLead } from "../../../../../slices/leads/types";
import { CompanyProfile } from "../../../models/ICompanyProfile";

const LeadModals = ({
  modals,
  setModals,
  selectedLead,
  companyProfile,
  isLoadingData,
}: {
  modals: any;
  setModals: any;
  selectedLead: SpecificLead;
  companyProfile: CompanyProfile | null;
  isLoadingData: boolean;
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [userAddress, setUserAddress] = useState("");
  const [origin, setOrigin]: any = useState();
  const [destination, setDestination]: any = useState({
    lat: 52.0522,
    lng: -0.2437,
  });

  // Function to close confirmation modal
  const handleCloseModal = () => {
    setModals((prev: any) => ({ ...prev, confirm: false }));
  };

  // Get handleConfirm from the custom hook
  const { handleConfirm } = useHandleConfirm(
    selectedLead,
    handleCloseModal,
    setIsLoading
  );

  // Handling address logic
  useEffect(() => {
    if (!selectedLead) return;

    const addressOne = selectedLead.addressOne;
    if (addressOne) {
      const result = `${addressOne.addressLineOne} , ${addressOne.addressLineTwo} , ${addressOne.city}  ${addressOne.state}  ${addressOne.country}`;

      setUserAddress(result);
      accessLocation(result, setOrigin, setDestination);
    }
  }, [selectedLead]);

  return (
    <LeadDetailsSubModals
      locationModal={modals.location}
      setSocialMediaModalShow={(state: boolean) =>
        setModals((prev: any) => ({ ...prev, social: state }))
      }
      destination={destination}
      handleCloseModal={handleCloseModal}
      socialMediaModal={modals.social}
      setLocationModalShow={(state: boolean) =>
        setModals((prev: any) => ({ ...prev, location: state }))
      }
      chatModal={modals.chat}
      setChatModalShow={(state: boolean) =>
        setModals((prev: any) => ({ ...prev, chat: state }))
      }
      origin={origin}
      isConfirmationModalShow={modals.confirm}
      isLoading={isLoading}
      handleConfirm={handleConfirm}
      userAddress={userAddress}
      companyProfile = {companyProfile}
      isLoadingData={isLoadingData}
      socialItems={selectedLead.socialsResponse}
      companyModal={modals.IdentityIntelligence}
      companyName= {selectedLead.company || ""}
      setCompanyModalShow={(state: boolean) =>
        setModals((prev: any) => ({
          ...prev,
          IdentityIntelligence: state,
        }))
      }
    />
  );
};

export default LeadModals;
